module.exports = __webpack_public_path__ + "media/src/website/images/locations/tegernsee/tegernsee_04-1cbb4d217a884b0eaaa4e7f1acec43b1.jpg";